import './instrument'

import { QueryClientProvider } from '@tanstack/react-query'
import { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router'
import { ThemeProvider } from 'styled-components'
import AppWithAuth from './components/AppWithAuth'
import AppErrorBoundary from './components/common/AppErrorBoundary'
import AppFallback from './components/common/AppFallback'
import { ToastContainer } from './components/common/Toast'
import PageTracker from './components/PageTracker'
import ScrollToTop from './components/ScrollToTop'
import { queryClient } from './lib/queryClient'
import GlobalStyles from './styles/GlobalStyles'
import { theme } from './styles/theme'

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <QueryClientProvider client={queryClient}>
        <AppErrorBoundary>
          <Suspense fallback={<AppFallback />}>
            <Router>
              <PageTracker />
              <ToastContainer />
              <ScrollToTop />
              <AppWithAuth />
            </Router>
          </Suspense>
        </AppErrorBoundary>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
